import { Input, Accordion } from '@itau-loans-www/components'

const BasicData = ({ control, isValid }) => {
  return (
    <Accordion title="Dados pessoais" initialOpen={!isValid}>
      <Input.Cpf
        label="CPF"
        id="cpf"
        data-cy="cy-input-cpf"
        name="cpf"
        autoComplete="on"
        control={control}
      />
      <Input.Name
        label="Nome completo"
        data-cy="cy-input-name"
        id="name"
        name="name"
        autoComplete="on"
        control={control}
      />
      <Input.Email
        label="E-mail"
        id="email"
        data-cy="cy-input-email"
        name="email"
        autoComplete="on"
        control={control}
      />
      <Input.Cellphone
        label="Celular"
        id="phone"
        data-cy="cy-input-phone"
        name="phone"
        mask="phone"
        autoComplete="on"
        control={control}
      />
    </Accordion>
  )
}

export default BasicData
